import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLoadService from "../../app/assetloading/AssetLoadService";
import AssetLoadServiceEvent from "../../app/assetloading/AssetLoadServiceEvent";
import AppModel from "../../app/core/AppModel";
import LanguageEvent from "./events/LanguageEvent";
import RTLTextPatch from "../../app/ui/text/RTLTextPatch";
import FontReplacementPatch from "../../app/ui/text/FontReplacementPatch";
import languagesConfig from "../../../../../src/assets/languages.json";

export default class InitLanguageTask extends Task {

    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {AssetLoadService} assetLoadService 
     * @param {AppModel} appModel 
     */
    constructor(dispatcher, assetLoadService, appModel) {
        super();

        this.execute = function (callback, progressCallback) {

            const language = appModel.language;
            console.log("InitLanguageTask", language);
            
            // Have RTL text patch use AppModel's rtl property to determine RTL mode
            RTLTextPatch.setRTLProvider(() => appModel.rtl);
            
            // Load languages configuration and populate font mapping
            if (languagesConfig && languagesConfig.languages) {
                // Build language-to-font mapping
                languagesConfig.languages.forEach(lang => {
                    if (lang.font) {
                        AppModel.languageFonts[lang.id] = lang.font;
                    }
                    if (lang.fontSizeMappings) {
                        AppModel.languageFontSizes[lang.id] = lang.fontSizeMappings;
                    }
                });
            }
            
            // Set font provider to use language-specific font from AppModel
            FontReplacementPatch.setFontProvider(() => {
                return AppModel.languageFonts[appModel.language] || null;
            });
            
            // Set font size provider to use language-specific size mappings from AppModel
            FontReplacementPatch.setFontSizeProvider(() => {
                return AppModel.languageFontSizes[appModel.language] || null;
            });
            
            //Load main language pack(s)
            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, () => {
                dispatcher.dispatch(LanguageEvent.INITIALIZED);

                callback(this);
            });
            assetLoadService.loadGroups("language");

        }
    }

}
